import React, {Component} from 'react';
import LinkConfirmDelete from './LinkConfirmDelete'

class GroupLinkDelete extends Component {
  render() {
    const {group, onDelete} = this.props
    const content = `Chắc chắn xoá địa bàn ${group.Name}?`
    return <LinkConfirmDelete title="Xoá địa bàn" content={content} object={group} onOk={onDelete}/>
  }
}

export default GroupLinkDelete;



// WEBPACK FOOTER //
// ./src/components/GroupLinkDelete.js